import $ from 'jquery';

const $document = $(document);
const $modal = $('.modal');
const $modalClose = $('.modal__close, .modal-close');
const $cookiesTrigger = $(".cookies-trigger");

$document.on('click', '.modal-trigger', function () {
    const $thisEl = $(this);
    const $targetModal = $($thisEl.data('target'));
    openModal($targetModal);
});
$document.on('click', '.modal', function () {
    const $targetModal = $document.find('.modal.active');
    closeModal($targetModal);
    $cookiesTrigger.trigger("focus");
});
$document.on('click', '.modal__wrapper > *', function (event) {
    event.stopImmediatePropagation();
});
$modalClose.on('click', function () {
    const $thisEl = $(this);
    const $targetModal = $thisEl.closest('.modal');
    closeModal($targetModal);
    $cookiesTrigger.trigger("focus");
});
$document.on('keydown', function (event) {
    const $targetModal = $document.find('.modal.active');
    if (event.key === 'Escape') {
        closeModal($targetModal);
        $cookiesTrigger.trigger("focus");
    }
});

// welcome modal behaviour

const $welcomeClose = $("#welcome-modal-close");
const $welcomeLast = $('.welcome-modal-last');
const $welcomeLink = $('.welcome-link');


$welcomeLast.on("keydown", function (event) {
    if (event.shiftKey && event.key === "Tab") {
      event.preventDefault();
      $welcomeLink.trigger("focus");
    } else if (event.key === "Tab") {
      event.preventDefault();
      $welcomeClose.trigger("focus");
    }
}); 

$welcomeClose.on("keydown", function (event) {
    if (event.shiftKey && event.key === "Tab") {
      event.preventDefault();
      $welcomeLast.trigger("focus");
    }
  });

// export modal function

export const openModal = targetModal => {
    if (
        targetModal !== undefined &&
        (typeof targetModal === 'string' ||
            typeof targetModal === 'object' ||
            selector instanceof $)
    ) {
        if (typeof targetModal === 'string' || typeof targetModal === 'object') {
            targetModal = $(targetModal);
        }

        if (targetModal.is(':hidden')) {
            targetModal.addClass('active');
            targetModal.fadeIn(400);
            targetModal.find('.modal__close').trigger('focus');
        }
    }
};

export const closeModal = targetModal => {
    if (
        targetModal !== undefined &&
        (typeof targetModal === 'string' ||
            typeof targetModal === 'object' ||
            selector instanceof $)
    ) {
        if (typeof targetModal === 'string' || typeof targetModal === 'object') {
            targetModal = $(targetModal);
        }

        if (targetModal.is(':visible')) {
            targetModal.removeClass('active');
            targetModal.fadeOut(400);


        }
    }
};




